import { IconButton, Stack, useMediaQuery, useTheme } from '@mui/material'
import { PropsWithChildren, useState } from 'react'
import { Swiper, useSwiper } from 'swiper/react'
import 'swiper/css'
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from '../../colors'

export const CollectionSlider = (props: PropsWithChildren) => {
  const { children } = props
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.up('sm'))
  const [swiper, setSwiper] = useState(useSwiper())
  const [isEnd, setIsEnd] = useState(false)
  const [isBeginning, setIsBeginning] = useState(false)

  const handleNavClick = (direction: 'prev' | 'next') => {
    setIsEnd(false)
    setIsBeginning(false)
    direction === 'prev' ? swiper.slidePrev() : swiper.slideNext()
  }

  return (
    <>
      <Stack
        className="swiperNav-container"
        sx={{
          maxWidth: theme.breakpoints.values.xl,
          position: 'absolute',
          top: -8,
          right: 0,
          zIndex: 2,
          m: 'auto',
          gap: 1,
          flexDirection: 'row',

          '.swiper, .swiper-container': {
            margin: md ? 0 : '0 -24px !important',
          },

          '.swiperNav': {
            display: ['block', null, 'none'],
            top: [null, null, null, 185, 225],
            zIndex: 1,
            width: 38,
            height: 38,

            '.MuiIconButton-root': {
              height: 38,
              width: 38,
              border: `1px solid ${colors.gray[5]}`,
              borderRadius: 3,
              path: {
                color: colors.gray[12],
                opacity: 1,
              },
            },
            '&--prev': {
              '.MuiIconButton-root': {
                path: isBeginning
                  ? {
                      color: colors.gray[5],
                    }
                  : '',
              },
            },
            '&--next': {
              '.MuiIconButton-root': {
                path: isEnd
                  ? {
                      color: colors.gray[5],
                    }
                  : '',
              },
            },
          },
        }}
      >
        <Stack className="swiperNav swiperNav--prev">
          <IconButton
            onClick={() => handleNavClick('prev')}
            disabled={isBeginning}
          >
            <FontAwesomeIcon fixedWidth icon={faChevronLeft} fontSize={16} />
          </IconButton>
        </Stack>
        <Stack className="swiperNav swiperNav--next">
          <IconButton onClick={() => handleNavClick('next')} disabled={isEnd}>
            <FontAwesomeIcon icon={faChevronRight} fontSize={16} />
          </IconButton>
        </Stack>
      </Stack>
      <Swiper
        onSwiper={(swiper) => {
          setSwiper(swiper)
          setIsBeginning(true)
        }}
        onSlideChange={(swiper) => {
          swiper.isBeginning ? setIsBeginning(true) : setIsBeginning(false)
          swiper.isEnd ? setIsEnd(true) : setIsEnd(false)
        }}
        grabCursor
        breakpoints={{
          0: {
            slidesPerView: 2.5,
            spaceBetween: 12,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
          [theme.breakpoints.values.sm]: {
            slidesPerView: 4.5,
            spaceBetween: 8,
          },
          [theme.breakpoints.values.md]: {
            slidesPerView: 6,
            spaceBetween: 12,
          },
          [theme.breakpoints.values.lg]: {
            slidesPerView: 6,
            spaceBetween: 16,
          },
        }}
        style={{ padding: '6px 0', margin: md ? '0' : '0 -24px' }}
      >
        {children}
      </Swiper>
    </>
  )
}
